/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Ctasubtitle1Inputs */

const he_extension_ctasubtitle1 = /** @type {(inputs: Extension_Ctasubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הצטרפו לאלפי משתמשים שכבר חוסכים מאות שקלים עם PriceDrop`)
};

const en_extension_ctasubtitle1 = /** @type {(inputs: Extension_Ctasubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join thousands of users already saving hundreds of shekels with PriceDrop`)
};

/**
* | output |
* | --- |
* | "Join thousands of users already saving hundreds of shekels with PriceDrop" |
*
* @param {Extension_Ctasubtitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_ctasubtitle1 = /** @type {((inputs?: Extension_Ctasubtitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Ctasubtitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_ctasubtitle1(inputs)
	return en_extension_ctasubtitle1(inputs)
});
export { extension_ctasubtitle1 as "extension_ctaSubtitle" }